import { observer } from 'mobx-react-lite'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import {
  AddInventoryItemsToEditDialog,
  InventoryItemListItem,
} from '@/features/admin/scope-change-requests/AddInventoryItemsToEditDialog'
import {
  type AddInventoryItemsToEditDialogViewModel,
  type EditScopeChangeInventoryItemToAddViewModel,
} from './AddInventoryItemsToEditDialogViewModel'

export interface AddInventoryItemsToEditDialogContainerProps {
  vm: AddInventoryItemsToEditDialogViewModel
}

export const AddInventoryItemsToEditDialogContainer = observer(
  function AddInventoryItemsToEditDialogContainer({
    vm,
  }: AddInventoryItemsToEditDialogContainerProps) {
    return (
      <AddInventoryItemsToEditDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        searchText={vm.searchText.value}
        onSearchTextChange={vm.searchText.change}
        selectedCount={vm.selectedInventoryItems.length}
        onAddItems={vm.addItems}
        loader={
          <InfiniteScrollLoaderContainer
            compact
            scrollProvider={vm.inventoryScrollProvider}
          />
        }
      >
        {vm.serviceItems.map((item) => {
          return (
            <InventoryItemListItemContainer key={item.versionId} item={item} />
          )
        })}
      </AddInventoryItemsToEditDialog>
    )
  },
)

interface InventoryItemListItemContainerProps {
  item: EditScopeChangeInventoryItemToAddViewModel
}

const InventoryItemListItemContainer = observer(
  function InventoryItemListItemContainer({
    item,
  }: InventoryItemListItemContainerProps) {
    return (
      <InventoryItemListItem
        name={item.name}
        description={item.description}
        selected={item.selected}
        onToggleSelected={item.toggleSelected}
      />
    )
  },
)
